import { Extension, Editor } from "@tiptap/core";

export interface KeyboardShortcutOptions {
  onSubmit: (props: { editor: Editor; options: any }) => void;
  onMeta: (props: { editor: Editor; options: any }) => void;
}

const Shortcut: Extension<KeyboardShortcutOptions, any> = Extension.create({
  name: "keyboardShortcut",
  priority: 2000,
  addOptions(): KeyboardShortcutOptions {
    return { onSubmit: () => false, onMeta: () => false };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Enter": () => {
        this.options.onSubmit({ editor: this.editor, options: this.options });
        return true;
      },
      "Mod-j": () => {
        this.options.onMeta({ editor: this.editor, options: this.options });
        return true;
      },
    };
  },
});

export default Shortcut;
